import React, { Component } from "react";
import PropTypes from "prop-types";
import Player from "./Player";

import Picks from "./Picks";
import QuarterSummary from "./QuarterSummary";
import { TeamShape } from "./nfl";
import { COLOR_GREEN, FONT_LEAGUE, FONT_THIN } from "./styles";

import range from "lodash/range";

const GRAY_TEXT = {
  color: "#aaa",
};

const STYLE_CITY = {
  fontSize: 64,
  textTransform: "uppercase",
};
const STYLE_SCORE = {
  fontSize: 144,
  fontFamily: "league-gothic-condensed, sans-serif",
  lineHeight: 0.8,
};
const STYLE_CONT_WINNER = {
  fontFamily: '"acumin-pro-extra-condensed",sans-serif',
  fontSize: 32,
  fontWeight: 300,
  textTransform: "capitalize",
};
const STYLE_CONT = Object.assign(
  {
    margin: "15px 0",
  },
  STYLE_CONT_WINNER,
);

const CELL_FONT_SIZE = {
  fontSize: 20,
};
const STYLE_CELL = Object.assign(
  {
    backgroundColor: "#555",
    color: "#aaa",
    fontSize: 20,
    textAlign: "center",
    userSelect: "none",
    alignSelf: "stretch",
    justifySelf: "stretch",
  },
  FONT_LEAGUE,
);
const STYLE_CELL_LABEL = Object.assign(
  {
    textAlign: "center",
    userSelect: "none",
  },
  CELL_FONT_SIZE,
);

const SELECTED_COLOR = COLOR_GREEN;
const OPACITY_FADED = { opacity: 0.5 };

function revInds(arr) {
  if (!arr) {
    return null;
  }
  const ret = Array(arr.length);
  arr.forEach((x, i) => {
    ret[x] = i;
  });
  return ret;
}

const RANGE = range(10);

const NORM = "normal";
const WIN = "win";
const CONT_AWAY = "cont_away";
const CONT_HOME = "cont_home";

function pendingValues(pending) {
  if (!pending || pending.length < 2) {
    return null;
  }
  return [pending[0], pending[1]];
}

class LabelCell extends Component {
  static propTypes = {
    val: PropTypes.number.isRequired,
    color: PropTypes.any.isRequired,
  };
  render() {
    const { color, val } = this.props;
    return <div style={Object.assign({ color }, STYLE_CELL_LABEL)}>{val}</div>;
  }
}

class GridHeader extends Component {
  render() {
    const { homeNums, labelColor } = this.props;
    return (
      <React.Fragment>
        {/* spacer for corner */}
        <div />
        {range(10).map((i) => <LabelCell key={i} val={homeNums.get(i)} color={labelColor} />)}
      </React.Fragment>
    );
  }
}

class GridCell extends Component {
  render() {
    const { val, cellStyle } = this.props;
    return (
      <div
        onClick={this.props.onClick}
        style={Object.assign(
          {
            backgroundColor: "gray",
            textAlign: "center",
            verticalAlign: "middle",
            padding: "25% 0",
          },
          cellStyle,
        )}
      >
        {val || "\u00A0"}
      </div>
    );
  }
}

class GridRow extends Component {
  static propTypes = {
    row: PropTypes.number.isRequired,
    picks: PropTypes.instanceOf(Picks).isRequired,
    awayInds: PropTypes.array,
    homeInds: PropTypes.array,
    scoreAway: PropTypes.number,
    scoreHome: PropTypes.number,
    awayPending: PropTypes.array,
    homePending: PropTypes.array,
  };

  squareType(row, col) {
    const { awayInds, homeInds } = this.props;
    if (!awayInds || !homeInds) {
      return NORM;
    }
    const { scoreAway, scoreHome } = this.props;
    const awayPending = pendingValues(this.props.awayPending);
    const homePending = pendingValues(this.props.homePending);
    if (awayInds[scoreAway % 10] === row && homeInds[scoreHome % 10] === col) {
      return WIN;
    } else if (
      awayPending &&
      ((awayInds[(awayPending[0] + scoreAway) % 10] === row &&
        homeInds[scoreHome % 10] === col) ||
        (awayInds[(awayPending[1] + scoreAway) % 10] === row &&
          homeInds[scoreHome % 10] === col))
    ) {
      return CONT_AWAY;
    } else if (
      homePending &&
      ((awayInds[scoreAway % 10] === row &&
        homeInds[(homePending[0] + scoreHome) % 10] === col) ||
        (awayInds[scoreAway % 10] === row &&
          homeInds[(homePending[1] + scoreHome) % 10] === col))
    ) {
      return CONT_HOME;
    }
    return NORM;
  }

  cellStyle(row, col) {
    const type = this.squareType(row, col);
    const { away, home, selectedPlayer, fadeDisabledCells } = this.props;
    const player = this.props.picks.getPlayer(row, col);

    const style = STYLE_CELL;
    if (type === WIN) {
      const { scoreAway, scoreHome } = this.props;
      if (scoreAway > scoreHome) {
        return Object.assign({}, style, {
          color: away.secondaryColor,
          backgroundColor: away.primaryColor,
        });
      } else if (scoreHome > scoreAway) {
        return Object.assign({}, style, {
          color: home.secondaryColor,
          backgroundColor: home.primaryColor,
        });
      } else {
        return Object.assign({}, style, { color: "white" });
      }
    } else if (type === CONT_HOME) {
      return Object.assign({}, style, {
        color: "white",
        backgroundColor: home.secondaryColor,
      });
    } else if (type === CONT_AWAY) {
      return Object.assign({}, style, {
        color: "white",
        backgroundColor: away.secondaryColor,
      });
    } else if (selectedPlayer && player && selectedPlayer.shortName === player.shortName) {
      return Object.assign({}, style, { color: SELECTED_COLOR });
    } else if (
      fadeDisabledCells &&
      (!selectedPlayer ||
        (player && selectedPlayer && selectedPlayer.shortName !== player.shortName))
    ) {
      return Object.assign({}, style, OPACITY_FADED);
    }
    return style;
  }

  render() {
    const { picks, row, showLabels } = this.props;
    return (
      <React.Fragment>
        {showLabels && (
          <LabelCell val={picks.awayNums.get(row)} color={this.props.away.secondaryColor} />
        )}
        {RANGE.map((col) => {
          const player = picks.getPlayer(row, col);
          const clickFn =
            this.props.onClickCell && !picks.locked
              ? (e) => {
                  e.preventDefault();
                  this.props.onClickCell && this.props.onClickCell(row, col);
                }
              : null;
          return (
            <GridCell
              key={col}
              val={player && player.shortName}
              cellStyle={this.cellStyle(row, col)}
              away={this.props.away}
              home={this.props.home}
              onClick={clickFn}
            />
          );
        })}
      </React.Fragment>
    );
  }
}

export class Grid extends Component {
  render() {
    const { picks, showLabels } = this.props;
    const awayInds = showLabels && revInds(picks.awayNums);
    const homeInds = showLabels && revInds(picks.homeNums);
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: (showLabels ? ["1em "] : []) + "1fr ".repeat(10),
          gridTemplateRows: showLabels ? "2em auto" : "auto",
          gridGap: 5,
          alignItems: "center",
          justifyItems: "center",
        }}
      >
        {showLabels && (
          <GridHeader
            homeNums={this.props.picks.homeNums}
            labelColor={this.props.home.secondaryColor}
          />
        )}
        {RANGE.map((i) => (
          <GridRow
            key={i}
            showLabels={showLabels}
            picks={this.props.picks}
            selectedPlayer={this.props.selectedPlayer}
            row={i}
            awayInds={awayInds}
            homeInds={homeInds}
            scoreAway={this.props.scoreAway}
            scoreHome={this.props.scoreHome}
            awayPending={this.props.awayPending}
            homePending={this.props.homePending}
            onClickCell={this.props.onClickCell}
            away={this.props.away}
            home={this.props.home}
          />
        ))}
      </div>
    );
  }
}
Grid.propTypes = {
  scoreAway: PropTypes.number,
  scoreHome: PropTypes.number,
  awayPending: PropTypes.array,
  homePending: PropTypes.array,

  onClickCell: PropTypes.func,
  picks: PropTypes.instanceOf(Picks),

  away: TeamShape,
  home: TeamShape,

  selectedPlayer: PropTypes.instanceOf(Player),
  fadeDisabledCells: PropTypes.bool,
};
Grid.defaultProps = {
  fadeDisabledCells: false,
};

class GridGameLayout extends Component {
  render() {
    const { away, home, picks, scoreAway, scoreHome, awayPending, homePending } = this.props;
    const curWinner = picks.winnerAt(scoreAway, scoreHome);
    const awayPendingVals = pendingValues(awayPending);
    const homePendingVals = pendingValues(homePending);

    const styleAwayColor = { color: away.primaryColor };
    const styleHomeColor = { color: home.primaryColor };
    const styleAwaySecondaryColor = { color: away.secondaryColor };
    const styleHomeSecondaryColor = { color: home.secondaryColor };

    let vsWinnerColor = null;
    if (scoreAway > scoreHome) {
      vsWinnerColor = away.primaryColor;
    } else if (scoreHome > scoreAway) {
      vsWinnerColor = home.primaryColor;
    }

    return (
      <div
        style={Object.assign(
          {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            margin: "10px auto 80px",
            padding: "0 10px",
            maxWidth: 600,
          },
          FONT_LEAGUE,
        )}
      >
        <div
          style={Object.assign(
            { gridRow: 1, gridColumn: "1 / 3" },
            styleAwaySecondaryColor,
            STYLE_CITY,
          )}
        >
          {away.short}
        </div>
        <div
          style={Object.assign(
            { gridRow: 1, gridColumn: "3 / 5", textAlign: "right" },
            styleHomeSecondaryColor,
            STYLE_CITY,
          )}
        >
          {home.short}
        </div>
        <div style={Object.assign({ gridRow: 2, gridColumn: 1 }, styleAwayColor, STYLE_SCORE)}>
          {scoreAway}
        </div>
        <div
          style={Object.assign(
            { gridRow: 2, gridColumn: "2 / 4", textAlign: "center" },
            { textAlign: "center", fontSize: 36, margin: "30px 0 0" },
            FONT_THIN,
            GRAY_TEXT,
            { fontWeight: 200 },
          )}
        >
          Current Winner:<br />
          <span style={{ color: vsWinnerColor }}>{curWinner.longName}</span>
        </div>
        <div
          style={Object.assign(
            { gridRow: 2, gridColumn: 4, textAlign: "right" },
            styleHomeColor,
            STYLE_SCORE,
          )}
        >
          {scoreHome}
        </div>
        <div
          style={Object.assign(
            { gridRow: 3, gridColumn: "1 / 3" },
            styleAwaySecondaryColor,
            STYLE_CONT,
          )}
        >
          {awayPendingVals && (
            <React.Fragment>
              <strong>+{awayPendingVals[0]}</strong>{" "}
              {picks.winnerAt(scoreAway + awayPendingVals[0], scoreHome).longName}
              <br />
              <strong>+{awayPendingVals[1]}</strong>{" "}
              {picks.winnerAt(scoreAway + awayPendingVals[1], scoreHome).longName}
            </React.Fragment>
          )}
        </div>
        <div
          style={Object.assign(
            { gridRow: 3, gridColumn: "3 / 5", textAlign: "right" },
            styleHomeSecondaryColor,
            STYLE_CONT,
          )}
        >
          {homePendingVals && (
            <React.Fragment>
              <strong>+{homePendingVals[0]}</strong>{" "}
              {picks.winnerAt(scoreAway, scoreHome + homePendingVals[0]).longName}
              <br />
              <strong>+{homePendingVals[1]}</strong>{" "}
              {picks.winnerAt(scoreAway, scoreHome + homePendingVals[1]).longName}
            </React.Fragment>
          )}
        </div>
        <div style={{ gridRow: 4, gridColumn: "1 / 5" }}>
          <Grid
            showLabels={true}
            picks={picks}
            away={away}
            home={home}
            scoreAway={scoreAway}
            scoreHome={scoreHome}
            awayPending={awayPending}
            homePending={homePending}
          />
        </div>
        <div style={{ gridRow: 5, gridColumn: "1 / 5" }}>
          <QuarterSummary
            picks={picks}
            away={away}
            home={home}
            awayPeriods={this.props.awayPeriods}
            homePeriods={this.props.homePeriods}
          />
        </div>
      </div>
    );
  }
}
GridGameLayout.propTypes = {
  picks: PropTypes.instanceOf(Picks).isRequired,
  scoreAway: PropTypes.number.isRequired,
  scoreHome: PropTypes.number.isRequired,
  awayPeriods: PropTypes.array,
  homePeriods: PropTypes.array,
  awayPending: PropTypes.array,
  homePending: PropTypes.array,

  away: TeamShape.isRequired,
  home: TeamShape.isRequired,
};

export default GridGameLayout;



// WEBPACK FOOTER //
// ./src/GridGameLayout.js